export { SearchBar } from './SearchBar';
export type { SearchBarProps } from './SearchBar';
export { VendorCard } from './VendorCard';
export type { VendorCardProps, VendorCardVendor } from './VendorCard';
export { VendorListItem } from './VendorListItem';
export type {
  VendorListItemProps,
  VendorListItemVendor,
  VendorBadge,
} from './VendorListItem';
export { VendorFilterSidebar } from './VendorFilterSidebar';
export type { VendorFilterSidebarProps } from './VendorFilterSidebar';
export { VendorSearchResults } from './VendorSearchResults';
export { VendorResultImpressions } from './VendorResultImpressions';
export type {
  VendorSearchResultsProps,
  VendorAugmentation,
} from './VendorSearchResults';
export { SortDropdown } from './SortDropdown';
export type { SortDropdownProps, SortOption } from './SortDropdown';
export { Icon } from './Icon';
export type { IconProps } from './Icon';
export { PromotionCard } from './PromotionCard';
export type { PromotionCardProps, PromotionCardOffer } from './PromotionCard';

// VBC detail components (presentational)
export {
  VBCHero,
  VBCTrustBadges,
  VBCAbout,
  VBCCategories,
  VBCLocations,
  VBCCredentials,
  VBCSpecialOffers,
  VBCContactBar,
} from './vbc';
export type {
  VBCHeroProps,
  VBCTrustBadgesProps,
  RenderedTrustBadge,
  VBCAboutProps,
  VBCCategoriesProps,
  CategoryItem,
  VBCLocationsProps,
  ServiceArea,
  VBCCredentialsProps,
  VBCSpecialOffersProps,
  SpecialOfferItem,
  VBCContactBarProps,
} from './vbc';

// VBC detail components (interactive / client)
export { VBCContactActions, VBCContactInfo } from './VBCContactActions';
export type { VBCContactActionsProps, VBCContactInfoProps } from './VBCContactActions';
export { VBCSaveButton } from './VBCSaveButton';
export type { VBCSaveButtonProps } from './VBCSaveButton';
export { VBCShareButton } from './VBCShareButton';
export type { VBCShareButtonProps } from './VBCShareButton';
export { VBCInquiryForm } from './VBCInquiryForm';
export type { VBCInquiryFormProps, InquiryFormData } from './VBCInquiryForm';
export { VBCQRCode } from './VBCQRCode';
export type { VBCQRCodeProps } from './VBCQRCode';

// Composed vendor detail page
export { VendorDetailPage } from './VendorDetailPage';
export type { VendorDetailPageProps, VendorDetailVendor } from './VendorDetailPage';
